import * as React from "react";
import GridMediaCard from "components/MediaLibrary/GridMediaCard/GridMediaCard";
import { CollectionFile } from "shared/types/files";
import { MediaCollection } from "api/media-library";

interface Props {
  files: CollectionFile[];
  selectedMediaSet: Map<string, CollectionFile>;
  onSelect(file: CollectionFile): void;
  onRemove(file: CollectionFile): void;
  selectedCollection: MediaCollection | null;
}

export function CollectionFilesList(props: Props) {
  const { files, onSelect, onRemove, selectedMediaSet, selectedCollection } =
    props;

  const firstSelectedExternalMedia = React.useMemo(() => {
    // if a collection is selected, will not show the tooltip
    // return null will skip the calculation
    return selectedCollection
      ? null
      : Array.from(selectedMediaSet.values()).find(
          (item) => item.picker !== "library"
        );
  }, [selectedCollection, selectedMediaSet]);

  return (
    <>
      {files.length > 0 && (
        <div className="mb-3">
          <p className="font-inter text-sm text-neutral-600">
            {files.length} {files.length === 1 ? "result" : "results"}
          </p>
        </div>
      )}
      <div
        className="grid grid-cols-[repeat(auto-fill,minmax(120px,1fr))] gap-3 items-start"
        data-testid="collectionFilesList"
      >
        {files.map((file, key) => {
          const isFileSelected = selectedMediaSet.has(file._id);
          const showCollectionTooltip =
            isFileSelected && firstSelectedExternalMedia?._id === file._id;

          if (!file.thumbnail && !file.downloadUrl) {
            return <></>;
          }

          return (
            <GridMediaCard
              key={file._id}
              asset={file}
              className="m-0 p-0 w-full h-full"
              order={key + 1}
              canSelect={false}
              canFavorite={false}
              selected={isFileSelected}
              showActionButtons={false}
              showCollectionTooltip={showCollectionTooltip}
              onCardClick={() =>
                isFileSelected ? onRemove(file) : onSelect(file)
              }
              isSourceMedia={true}
            />
          );
        })}
      </div>
    </>
  );
}
